import Page from './index';

export default { path: '/home/tenant/spotCoin', component: Page };
